import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BlogService } from "src/app/services/blog.service";

@Component({
	selector: "app-campaign",
	templateUrl: "./campaign.component.html",
	styleUrls: ["./campaign.component.css"]
})
export class CampaignComponent implements OnInit {
	campaign: any;

	constructor(private blogService: BlogService, private route: ActivatedRoute) {
		this.route.params.subscribe((params: any) => {
			if (params.id != "undefined") {
				this.load(params.id);
			}
		});
	}

	ngOnInit(): void {
	}

	load(id: string) {
		this.blogService.one(id).subscribe((data: any) => {
			if (data.status === "OK") {
				this.campaign = data.data;
			}
		});
	}

	getCategories(campaign: any) {
		let names = campaign.categories.map((p: any) => p.name);
		return names.join(', ');
	}
}
